/*
 * Module for the Tax Table and Rates' Tax Table Detail page.
*/
rs.module("system_/configuration/taxtablesandrates/taxtabledetail",

    [
        "controls/data/grid",
        "controls/components/event-banner",
        "common/visibility"
    ],

    function (gridModule, eventBanner, visibility) {

        var _executeStateSelectionChanged;
        var _executeFedSelectionChanged;

        //
        // Initialize
        //
        function initialize(jsSelectors, lrsGridApi, stateAllowanceGrid, federalAllowanceGrid, backendUrls, detailCriteria, currentDate) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var hiddenNewRatesFlag = criteria.js(jsSelectors.hiddenNewRatesFlag);
            var detailsNotFoundWarning = criteria.js(jsSelectors.detailsNotFoundWarning);
            var asOfDateInput = criteria.js(jsSelectors.asOfDateInput);
            var asOfDateSpinner = criteria.js(jsSelectors.asOfDateSpinner);
            var taxTableGridError = criteria.js(jsSelectors.taxTableGridError);
            var taxTableGridAddButton = criteria.js(jsSelectors.taxTableGridAddButton);
            var taxTableEffectiveDateInput = criteria.js(jsSelectors.taxTableEffectiveDateInput);
            var taxTableTerminationDateInput = criteria.js(jsSelectors.taxTableTerminationDateInput);
            var taxTableSaveButton = criteria.js(jsSelectors.taxTableSaveButton);
            var taxTableBackButton = criteria.js(jsSelectors.taxTableBackButton);
            var taxTableCancelButton = criteria.js(jsSelectors.taxTableCancelButton);
            var newTablePeriodButton = criteria.js(jsSelectors.newTablePeriodButton);
            var hiddenTaxYearExemptionKey = criteria.js(jsSelectors.hiddenTaxYearExemptionKey);
            var allowanceUpdateToken = criteria.js(jsSelectors.allowanceUpdateToken);
            var allowanceHistoryAddButton = criteria.js(jsSelectors.allowanceHistoryAddButton);
            var allowanceAmountInput = criteria.js(jsSelectors.allowanceAmountInput);
            var allowanceEffectiveDateInput = criteria.js(jsSelectors.allowanceEffectiveDateInput);
            var allowanceTerminationDateInput = criteria.js(jsSelectors.allowanceTerminationDateInput);
            var allowanceCancelButton = criteria.js(jsSelectors.allowanceCancelButton);

            // Handle as of date key down event
            asOfDateInput.on("keydown",
                function (event) {
                    if (event.which == 13) {
                        // by default forms will submit when Enter is pressed, this suppresses that behavior
                        return false;
                    }
                }
            );

            // Hook up the 'As of Date' change event
            asOfDateInput.change(_.debounce(function () {

                eventBanner.removeAllMessages();
                hiddenNewRatesFlag.val(false);

                // Change button visibility
                visibility.hide(taxTableCancelButton);
                visibility.show(taxTableBackButton);
                visibility.show(newTablePeriodButton);

                if (asOfDateInput.val() && asOfDateInput.valid()) {
                    loadTaxTableGrid();
                }
            }, 500));

            // When taxTableGridAddButton clicked, add new defaulted row to the correct detail grid.
            taxTableGridAddButton.click(function () {

                eventBanner.removeAllMessages();
                taxTableGridError.text('');
                lrsGridApi.addRow();
            });

            // Setup the Tax Table card for adding a new table period
            newTablePeriodButton.click(function () {

                eventBanner.removeAllMessages();

                // Clear Tax Table criteria
                [
                    asOfDateInput,
                    taxTableEffectiveDateInput,
                    taxTableTerminationDateInput
                ].forEach((input) => input.clearErrors().val(''));

                // Clear Tax Table grid
                lrsGridApi.clearGridRows();

                hiddenNewRatesFlag.val(true);

                // Change button visibility
                visibility.show(taxTableGridAddButton);
                visibility.show(taxTableCancelButton);
                visibility.hide(taxTableBackButton);
                visibility.hide(newTablePeriodButton);
                visibility.hide(detailsNotFoundWarning);

                // Ensure fields and buttons enabled
                taxTableEffectiveDateInput.prop('disabled', false);
                taxTableTerminationDateInput.prop('disabled', false);
                taxTableSaveButton.setDisabled(false);
                taxTableBackButton.setDisabled(false);
                taxTableCancelButton.setDisabled(false);
            });

            // Setup the Tax Table cancel button click event
            taxTableCancelButton.click(function () {

                // Clear event banner.
                eventBanner.removeAllMessages();

                // Set as of date input and reload grid
                asOfDateInput.val(currentDate);
                loadTaxTableGrid();

                // Set hidden new rates flag
                hiddenNewRatesFlag.val(false);

                // Change button visibility
                visibility.hide(taxTableCancelButton);
                visibility.show(taxTableBackButton);
                visibility.show(newTablePeriodButton);
            });

            // On allowance grid selection change, set allowance input fields
            if (detailCriteria.isState) {

                stateAllowanceGrid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeStateSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeStateSelectionChanged && values.length > 0) {

                        eventBanner.removeAllMessages();

                        // Clear Allowance criteria
                        clearAllowanceCriteria();

                        if (values.length > 0) {
                            $.getJSON(
                                backendUrls.getStateAllowanceDataAsync,
                                { stateExemptionKey: values[0] })
                                .done(function (data) {
                                    allowanceUpdateToken.val(data.updateToken);
                                    hiddenTaxYearExemptionKey.val(data.allowanceKey);
                                    allowanceAmountInput.val(data.allowanceAmount);
                                    allowanceEffectiveDateInput.val(data.effectiveDate);
                                    allowanceTerminationDateInput.val(data.terminationDate);
                                });
                        }
                    }

                    _executeStateSelectionChanged = true;
                });
            }
            else {

                federalAllowanceGrid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeFedSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeFedSelectionChanged && values.length > 0) {

                        eventBanner.removeAllMessages();

                        // Clear Allowance criteria
                        clearAllowanceCriteria();

                        if (values.length > 0) {
                            $.getJSON(
                                backendUrls.getFederalAllowanceDataAsync,
                                { federalExemptionKey: values[0] })
                                .done(function (data) {
                                    allowanceUpdateToken.val(data.updateToken);
                                    hiddenTaxYearExemptionKey.val(data.allowanceKey);
                                    allowanceAmountInput.val(data.allowanceAmount);
                                    allowanceEffectiveDateInput.val(data.effectiveDate);
                                    allowanceTerminationDateInput.val(data.terminationDate);
                                });
                        }
                    }

                    _executeFedSelectionChanged = true;
                });
            }

            // On allowance grid add button click, de-select grid and clear allowance input fields
            allowanceHistoryAddButton.click(function () {

                eventBanner.removeAllMessages();

                if (detailCriteria.isState) {
                    stateAllowanceGrid.selectedValues = null;
                }
                else {
                    federalAllowanceGrid.selectedValues = null;
                }

                clearAllowanceCriteria();
            });


            // On allowance grid cancel button click, clear criteria and re-select first item in row 
            allowanceCancelButton.click(function () {

                eventBanner.removeAllMessages();
                clearAllowanceCriteria();

                if (detailCriteria.isState) {
                    stateAllowanceGrid.selectedValues = null;
                    stateAllowanceGrid.selectFirstRow();
                }
                else {
                    federalAllowanceGrid.selectedValues = null;
                    federalAllowanceGrid.selectFirstRow();
                }
            });

            // Load the tax table grid given the 'As of Date'
            function loadTaxTableGrid() {

                asOfDateSpinner.show();

                gridModule.update(
                    backendUrls.getTaxTableGridAsync,
                    {
                        asOfDate: asOfDateInput.val(),
                        state: detailCriteria.stateCd,
                        filingStatus: detailCriteria.filingStatus,
                        frequency: detailCriteria.frequency
                    },
                    lrsGridApi.agGridApi,
                    function done(gridUpdate) {

                        if (gridUpdate.rowData.length > 0) {
                            visibility.hide(detailsNotFoundWarning);
                            taxTableEffectiveDateInput.val(gridUpdate.context.effectiveDate ? new Date(gridUpdate.context.effectiveDate).toISODateString() : null).clearErrors();
                            taxTableTerminationDateInput.val(gridUpdate.context.terminationDate ? new Date(gridUpdate.context.terminationDate).toISODateString() : null).clearErrors();

                            visibility.show(taxTableGridAddButton);
                            taxTableEffectiveDateInput.prop('disabled', false);
                            taxTableTerminationDateInput.prop('disabled', false);
                            taxTableSaveButton.setDisabled(false);
                            taxTableBackButton.setDisabled(false);
                            taxTableCancelButton.setDisabled(false);

                            taxTableGridError.text('');
                        }
                        else {
                            taxTableEffectiveDateInput.clearErrors().val('');
                            taxTableTerminationDateInput.clearErrors().val('');

                            visibility.hide(taxTableGridAddButton);

                            taxTableEffectiveDateInput.prop('disabled', true);
                            taxTableTerminationDateInput.prop('disabled', true);
                            taxTableSaveButton.setDisabled();
                            taxTableBackButton.setDisabled();
                            taxTableCancelButton.setDisabled();

                            visibility.show(detailsNotFoundWarning);
                        }

                        asOfDateSpinner.hide();
                    }
                );
            }

            // Clear criteria related to the Allowance Card
            function clearAllowanceCriteria() {
                hiddenTaxYearExemptionKey.val(-1);
                [
                    allowanceUpdateToken,
                    allowanceAmountInput,
                    allowanceEffectiveDateInput,
                    allowanceTerminationDateInput
                ].forEach((input) => input.clearErrors().val(''));
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);